// @ts-check
/**
 * Formatação para pt-BR, num lugar só. No app antigo cada tela repetia
 * `toLocaleString("pt-BR", {...})` com opções levemente diferentes.
 */

/** @type {Intl.DateTimeFormatOptions} */
const DATA_HORA = { dateStyle: "short", timeStyle: "short" };

/** @param {string | Date | null | undefined} valor */
export function formatDateTime(valor) {
  const d = toDate(valor);
  return d ? d.toLocaleString("pt-BR", DATA_HORA) : "—";
}

/** @param {string | Date | null | undefined} valor */
export function formatDate(valor) {
  const d = toDate(valor);
  return d ? d.toLocaleDateString("pt-BR") : "—";
}

/** @param {string | Date | null | undefined} valor */
export function formatTime(valor) {
  const d = toDate(valor);
  return d ? d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "—";
}

/**
 * Hora se for hoje, data curta + hora se for antes — o formato usado na
 * lista de conversas do WhatsApp.
 * @param {string | Date | null | undefined} valor
 */
export function formatMessageTime(valor) {
  const d = toDate(valor);
  if (!d) return "";
  const hoje = d.toDateString() === new Date().toDateString();
  return hoje
    ? d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
}

/** @param {number | null | undefined} valor */
export function formatCurrency(valor) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor ?? 0);
}

/** @param {number | null | undefined} valor */
export function formatNumber(valor) {
  return new Intl.NumberFormat("pt-BR").format(valor ?? 0);
}

/** Iniciais para avatar: "Débora Martins" → "DM". */
export function initials(nome, max = 2) {
  if (!nome) return "?";
  return nome
    .trim()
    .split(/\s+/)
    .map((parte) => parte[0])
    .slice(0, max)
    .join("")
    .toUpperCase();
}

/** Telefone só com dígitos, para comparar números vindos da Meta. */
export function onlyDigits(valor) {
  return (valor ?? "").replace(/\D/g, "");
}

function toDate(valor) {
  if (!valor) return null;
  if (valor instanceof Date) return Number.isNaN(valor.getTime()) ? null : valor;
  // O SQLite grava "2026-08-31 12:00:00" (sem T e sem fuso); normalizamos
  // para que o navegador não interprete como horário local errado.
  const texto = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(valor)
    ? valor.replace(" ", "T") + "Z"
    : valor;
  const d = new Date(texto);
  return Number.isNaN(d.getTime()) ? null : d;
}
